import { isEmpty } from 'lodash'
import { useCallback, useEffect } from 'react'

const useCanvasContext = ({ stageRef, editingStageRef }) => {
  const handleContextLost = useCallback(e => {
    e.preventDefault()
    // console.error('⚠️ WebGL Context Lost!.')
  }, [])

  const handleContextRestored = useCallback(() => {
    // console.log('✅ WebGL Context Restored. Trying to redraw.')
    if (stageRef.current) {
      stageRef.current.batchDraw()
    }
    if (editingStageRef.current) {
      editingStageRef.current.batchDraw()
    }
  }, [ editingStageRef, stageRef ])

  useEffect(() => {
    const canvasElements = stageRef.current?.container().querySelectorAll('canvas')
    const editingTransformerCanvasElements = editingStageRef.current?.container().querySelectorAll('canvas')

    if (!isEmpty(canvasElements)) {
      canvasElements.forEach(canvasElem => {
        canvasElem.addEventListener('webglcontextlost', handleContextLost, false)
        canvasElem.addEventListener('webglcontextrestored', handleContextRestored, false)
      })
    }
    if (!isEmpty(editingTransformerCanvasElements)) {
      editingTransformerCanvasElements.forEach(canvasElem => {
        canvasElem.addEventListener('webglcontextlost', handleContextLost, false)
        canvasElem.addEventListener('webglcontextrestored', handleContextRestored, false)
      })
    }
    return () => {
      if (!isEmpty(canvasElements)) {
        canvasElements.forEach(canvasElem => {
          canvasElem.removeEventListener('webglcontextlost', handleContextLost, false)
          canvasElem.removeEventListener('webglcontextrestored', handleContextRestored, false)
        })
      }
      if (!isEmpty(editingTransformerCanvasElements)) {
        editingTransformerCanvasElements.forEach(canvasElem => {
          canvasElem.removeEventListener('webglcontextlost', handleContextLost, false)
          canvasElem.removeEventListener('webglcontextrestored', handleContextRestored, false)
        })
      }
    }
  }, [ handleContextLost, handleContextRestored, stageRef, editingStageRef ])
}

export default useCanvasContext
